import React from 'react'
import LegacyButton from './LegacyButton'
import QuoteModalButton from './QuoteModalButton'
import { isIE11 } from '../../../../util/IE11'

export default function QuoteButton() {
  return isIE11 ? <LegacyButton /> : <QuoteModalButton />
}
